import { render, staticRenderFns } from "./CrashGame.vue?vue&type=template&id=2121c208&scoped=true"
import script from "./CrashGame.vue?vue&type=script&lang=js"
export * from "./CrashGame.vue?vue&type=script&lang=js"
import style0 from "./CrashGame.vue?vue&type=style&index=0&id=2121c208&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2121c208",
  null
  
)

export default component.exports